import { DefaultTheme } from 'styled-components';

/**
 * Get color for a delta value based on its sign
 * @param value - The delta value (positive, negative, or zero)
 * @param theme - The styled-components theme
 * @returns Color string from theme tokens
 */
export const getDeltaColorBySign = (value: number, theme: DefaultTheme, changeReverse = false): string => {
  if (value > 0) return changeReverse ? theme.colors.error : theme.colors.success;
  if (value < 0) return changeReverse ? theme.colors.success : theme.colors.error;
  return theme.colors.text.tertiary; // neutral gray for zero
};

/**
 * Format a number with a sign prefix
 * @param value - The number to format
 * @returns Formatted string with '+' for positive, '-' for negative, or '0' for zero
 */
export const formatSigned = (value: number): string => {
  if (value === 0) return '0';
  return `${value > 0 ? '+' : ''}${value}`;
};

